"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridContainerConfig = exports.gridConfig = void 0;
var gridContainerConfig = exports.gridContainerConfig = {
  maxWidth: '128rem'
};

// minWidth and maxWidth use default browser setting hence different calculation
// calculation explanation:
// (x * 0.625). x - normal rem (using root value);
// 0.625 - accommodate for the use of default setting from browser
var gridConfig = exports.gridConfig = {
  xxs: {
    gutter: '0.8rem',
    margin: '1.6rem',
    maxWidth: "".concat(35.9 * 0.625, "rem"),
    minWidth: '0rem'
  },
  xs: {
    gutter: '0.8rem',
    margin: '1.6rem',
    maxWidth: "".concat(37.4 * 0.625, "rem"),
    minWidth: "".concat(36 * 0.625, "rem")
  },
  s: {
    gutter: '0.8rem',
    margin: '1.6rem',
    maxWidth: "".concat(76.7 * 0.625, "rem"),
    minWidth: "".concat(37.5 * 0.625, "rem")
  },
  m: {
    gutter: '1.2rem',
    margin: '2.4rem',
    maxWidth: "".concat(102.3 * 0.625, "rem"),
    minWidth: "".concat(76.8 * 0.625, "rem")
  },
  l: {
    gutter: '1.2rem',
    margin: '2.4rem',
    maxWidth: "".concat(143.9 * 0.625, "rem"),
    minWidth: "".concat(102.4 * 0.625, "rem")
  },
  xl: {
    gutter: '1.6rem',
    margin: '8rem',
    maxWidth: "".concat(191.9 * 0.625, "rem"),
    minWidth: "".concat(144 * 0.625, "rem")
  },
  xxl: {
    gutter: '1.6rem',
    margin: '8rem',
    maxWidth: '',
    minWidth: "".concat(192 * 0.625, "rem")
  }
};